import api from '../../api'
import {
  GET_CHARGE_LIST_SUCCESS,
  GET_CHARGE_LIST_FAILURE,
  GET_CHARGE_FAILURE,
  GET_CHARGE_SUCCESS,
  UPDATE_CHARGE_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getChargeList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getChargeList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        return commit(GET_CHARGE_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_CHARGE_LIST_SUCCESS, {
        chargeList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_CHARGE_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanChargeList({commit}) {
    return commit(GET_CHARGE_LIST_FAILURE)
  },
  
  getCharge({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getCharge(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_CHARGE_FAILURE);
            reject();
          }
          commit(GET_CHARGE_SUCCESS, {
            charge: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_CHARGE_FAILURE);
          reject();
        })
    })
  },
 
  
  updateCharge({commit}, data) {
    return new Promise((resolve, reject) => {

      if(data.valueFactor == undefined){
        data.valueFactor = null
      }

      if(data.valueCentavos == undefined){
        data.valueCentavos = null
      }

      api.startLoader()
      let avaliables = [
        "id",
        "formattedValueFactor",
        "formattedValueCentavos",
        "valueFactor",
        "valueCentavos",
        "ChargeTypeId"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateCharge(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createCharge({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      if(data.valueFactor == undefined){
        data.valueFactor = null
      }

      if(data.valueCentavos == undefined){
        data.valueCentavos = null
      }
  
      
      api.createCharge(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteCharge({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteCharge(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_CHARGE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.charge));
  },
  [GET_CHARGE_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_CHARGE_LIST_SUCCESS](state, action) {
    state.list = action.chargeList;
    state.listUpdated = new Date();
  },
  [GET_CHARGE_FAILURE](state) {
    state.selected = null
  },
  [GET_CHARGE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.charge));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/charge.js